"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
var _helpers = require("./../../utils/helpers.js");
var _StringListModule = _interopRequireDefault(require("../../scss/utils/StringList.module.scss"));
function StringList({
  list,
  separatorType = 'comma',
  makeBlock = false
}) {
  const filteredList = list.filter(item => !(item === '' || item === undefined || item === null));
  switch (separatorType) {
    case 'comma':
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _helpers.classes)(['string-list', makeBlock ? _StringListModule.default['string-list--block'] : ''])
      }, filteredList.map((item, index) => {
        if (index === 0) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
            key: `sl-${Math.round(Math.random() * 10000000)}`
          }, typeof item === 'string' ? (0, _htmlReactParser.default)(item) : item);
        }
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: `sl-${Math.round(Math.random() * 10000000)}`
        }, ", ", typeof item === 'string' ? (0, _htmlReactParser.default)(item) : item);
      }));
    case 'pipe':
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _helpers.classes)(['string-list', makeBlock ? _StringListModule.default['string-list--block'] : ''])
      }, filteredList.map((item, index) => {
        if (index === 0) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
            key: `sl-${Math.round(Math.random() * 10000000)}`
          }, typeof item === 'string' ? (0, _htmlReactParser.default)(item) : item);
        }
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: `sl-${Math.round(Math.random() * 10000000)}`
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: (0, _helpers.classes)([_StringListModule.default['string-list__pipe'], 'string-list__pipe'])
        }, " | "), typeof item === 'string' ? (0, _htmlReactParser.default)(item) : item);
      }));
    default:
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  }
}
var _default = exports.default = StringList;